import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment'; // import environment

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('lccore_token');
    // Kalau production, langsung terusin tanpa inject Authorization
    if (environment.production) {
      return next.handle(req);
    }

    if (token) {
      // clone request dan tambahin header Authorization
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(authReq);
    }

    // kalau nggak ada token, kirim request apa adanya
    return next.handle(req);
  }
}
